(function () {
  var NAVY = '#142c73';
  var LIGHTBLUE = '#4a90d9';
  var FIELDS = [
    { label: 'Years in Business', name: 'extra_years_business', id: 'wpd_years_business', required: true,
      options: ['Under 1 Year', '1-2 Years', 'Over 3 Years'] },
    { label: 'Type of Retailer / Seller', name: 'extra_retailer_type', id: 'wpd_retailer_type', required: true,
      options: ['E-commerce', '1-2 Physical Locations', '3+ Locations', '10+ Locations', '3rd Party Online Reseller'] },
    { label: 'How did you hear about us?', name: 'extra_hear_about', id: 'wpd_hear_about', required: false,
      options: ['Google Search', 'Trade Show', 'Referral', 'Social Media', 'Sales Representative', 'Other'] }
  ];
  function build(f) {
    var div = document.createElement('div');
    div.className = 'wpd_clearfix';
    var lbl = document.createElement('label');
    lbl.className = 'login';
    lbl.htmlFor = f.id;
    lbl.textContent = (f.required ? '* ' : '') + f.label;
    var sel = document.createElement('select');
    sel.name = f.name; sel.id = f.id; sel.className = 'large';
    if (f.required) sel.required = true;
    var ph = document.createElement('option');
    ph.value = ''; ph.textContent = 'Please select'; if (f.required) { ph.disabled = true; } ph.selected = true;
    sel.appendChild(ph);
    f.options.forEach(function (o) { var op = document.createElement('option'); op.value = o; op.textContent = o; sel.appendChild(op); });
    sel.style.cssText = 'width:100%;max-width:100%;padding:10px;margin-bottom:10px;box-sizing:border-box;display:block;';
    div.appendChild(lbl); div.appendChild(sel);
    return div;
  }
  function mergeIntoTitle() {
    var title = document.getElementById('wpd_title');
    if (!title) return;
    var base = (title.value || '').split(' ||')[0];
    var yrs = (document.getElementById('wpd_years_business') || {}).value || '';
    var typ = (document.getElementById('wpd_retailer_type') || {}).value || '';
    var hear = (document.getElementById('wpd_hear_about') || {}).value || '';
    var parts = [];
    if (yrs) parts.push('Years in Business: ' + yrs);
    if (typ) parts.push('Type of Retailer: ' + typ);
    if (hear) parts.push('Heard About Us: ' + hear);
    title.value = base + (parts.length ? ' || ' + parts.join(' | ') : '');
  }
  function findHeading(matchFn) {
    var els = document.querySelectorAll('h1,h2,h3,h4,.title,.section__heading,.rich-text__heading,p,span,div');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.children.length === 0 && matchFn((el.textContent || '').trim())) return el;
    }
    return null;
  }
  function restyle() {
    var form = document.getElementById('create_customer');
    if (!form) return;
    if (!document.getElementById('plw-form-style')) {
      var st = document.createElement('style');
      st.id = 'plw-form-style';
      st.textContent =
        '#create_customer{border:2px solid ' + NAVY + ';border-radius:12px;padding:28px;background:#fff;box-sizing:border-box;}' +
        '#create_customer button,#create_customer input[type=submit]{background:' + LIGHTBLUE + ' !important;border-color:' + LIGHTBLUE + ' !important;color:#fff !important;}' +
        '#plw-form-head{text-align:center;margin:4px 0 20px;}' +
        '#plw-form-head .plw-h{margin:0;font-size:32px;font-weight:700;color:' + NAVY + ';}' +
        '#plw-form-head .plw-sub{margin:6px 0 0;font-size:14px;color:' + NAVY + ';opacity:.7;}' +
        '#plw-submit-row{clear:both;text-align:center;padding-top:18px;width:100%;}' +
        '#plw-submit-row button{min-width:300px;}';
      document.head.appendChild(st);
    }
    if (!document.getElementById('plw-form-head')) {
      var signupH = findHeading(function (t) { return t.indexOf('Retail Partner') !== -1; });
      var createH = findHeading(function (t) { return t === 'Create Account'; });
      var head = document.createElement('div');
      head.id = 'plw-form-head';
      head.innerHTML = '<div class="plw-h">Retailer Sign Up Form</div><div class="plw-sub">Submissions may take 24-48 Hours</div>';
      form.parentNode.insertBefore(head, form);
      if (signupH) {
        signupH.style.display = 'none';
        var sec = signupH.closest('section, .shopify-section, .section');
        if (sec) { sec.style.paddingTop = '0'; sec.style.paddingBottom = '0'; sec.style.marginTop = '0'; sec.style.marginBottom = '0'; sec.style.minHeight = '0'; }
      }
      if (createH) { createH.style.display = 'none'; }
    }
    if (!document.getElementById('plw-submit-row')) {
      var btns = form.querySelectorAll('button, input[type=submit]');
      var btn = null;
      for (var j = 0; j < btns.length; j++) { if ((btns[j].innerText || btns[j].value || '').toUpperCase().indexOf('CREATE') !== -1) { btn = btns[j]; break; } }
      if (btn) {
        var row = document.createElement('div');
        row.id = 'plw-submit-row';
        form.appendChild(row);
        row.appendChild(btn);
      }
    }
    var b = document.querySelector('#plw-submit-row button, #plw-submit-row input[type=submit]');
    if (b) {
      if (b.tagName === 'BUTTON' && b.textContent.toUpperCase().indexOf('SUBMIT APPLICATION') === -1) { b.textContent = 'SUBMIT APPLICATION'; }
      else if (b.tagName === 'INPUT' && (b.value || '').toUpperCase().indexOf('SUBMIT APPLICATION') === -1) { b.value = 'SUBMIT APPLICATION'; }
    }
  }
  function init() {
    var form = document.getElementById('create_customer');
    if (!form) return;
    if (!document.getElementById('wpd_retailer_type')) {
      var anchor = document.getElementById('title') || document.getElementById('company');
      var parent = anchor ? anchor.parentNode : form;
      var ref = anchor ? anchor.nextSibling : form.firstChild;
      FIELDS.forEach(function (f) { parent.insertBefore(build(f), ref); });
    }
    if (!form.__plwHooked) {
      form.__plwHooked = true;
      form.addEventListener('submit', mergeIntoTitle, true);
      var bs = form.querySelectorAll('button, input[type="submit"]');
      for (var i = 0; i < bs.length; i++) { bs[i].addEventListener('click', mergeIntoTitle, true); }
    }
    restyle();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  var tries = 0;
  var t = setInterval(function () { init(); if (++tries > 12) clearInterval(t); }, 700);
})();
